import { render, staticRenderFns } from "./LinkIcon.vue?vue&type=template&id=6a4250bf&scoped=true"
var script = {}
import style0 from "./LinkIcon.vue?vue&type=style&index=0&id=6a4250bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4250bf",
  null
  
)

export default component.exports